export const colours = {
	red: '#ff595e',
	green: '#8ac926',
	blue: '#1982c4',
	yellow: '#ffca3a',
	purple: '#6a4c93',
	grey: '#999999',
};

// An indexable list of the colours
export const palette: string[] = [colours.red, colours.green, colours.blue, colours.yellow, colours.purple, colours.grey];